export default class FeathersFactoryError extends Error {}
export class FeathersServiceNotDefined extends FeathersFactoryError {}
